<template>
  <div>
    <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      center
    >
      <div class="content">
        <div class="content_tops">
          <el-input v-model="data.name" placeholder="请输入未授权产品名称"></el-input>
          <div class="top_btns" @click="productBtns">搜索</div>
        </div>
        <div class="contentQp">
        <div class="qpLeft" ref="evabox" @scroll="Scroll">
          <div v-for="(item,index) in notEmpow" :key='index' class="empow" >
            <el-checkbox v-model="item.checked"  @change="$forceUpdate()"></el-checkbox>
            <span style="margin-left:1rem;">{{ item.ProductName }}</span>
          </div>
        </div>
        <div class="qpCenter">
          <!-- <div class="qpCenter_input">
            <span>商品价格</span>
            <el-input placeholder="价格" v-model="price"></el-input>
          </div> -->
          <div class="qpCenter_btns">
             <div @click="select">选择</div>
             <div @click="select1">全部选择</div>
             <div @click="closeContent">取消</div>
             <div @click="closeCon1">全部取消</div>
          </div>
        </div>
        <div class="qpRight"  ref="evabox1" @scroll="Scroll1">
          <div v-for="(item,index) in empower" :key="index" class="empow" >
            <el-checkbox v-model="item.checked"   @change="$forceUpdate()"></el-checkbox>
            <span style="margin-left:1rem;">{{ item.ProductName }}</span>
          </div>
        </div>
        </div>
        <div class="contentBtns">
            <div @click="btnsClose">取消授权</div>
            <div @click="Bnts" style="margin-left:2rem;">确认授权</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {ImpowerProduct,GetScenicList,WshopList,WshopDetele} from '@/request/scenic.js'
import {Message } from 'element-ui'
  export default{
    data(){
      return{
        addProDialogVisible:false,
        titleType:'',
        notEmpow:[],
        empower:[],
        price:'',
        ProductID:'',
        JFYPrice:'',
        data:{
          token:window.sessionStorage.getItem('Token'),
          page:1,
          page_size:50,
          name:''
        },
        flag:true,
        data2:{
          token:window.sessionStorage.getItem('Token'),
          page:1,
          page_size:50
        },
        flag1:true
      }
    },
    created(){
      this.wxshopList()
      this.getList()
    },
    methods:{
      productBtns(){
        this.notEmpow = []
        this.data.page = 1
        this.getList()
      },
      Scroll1(e){
        const ele = e.srcElement ? e.srcElement : e.target
         // 监听滚动到div底部
        if (ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100) { 
          if (this.flag1 == false) {//避免多次请求 加锁 该次请求完成 才能再次发起请求
            this.flag1 = true
            this.data2.page += 1
            this.wxshopList()
          }
        }
        
      },
      wxshopList(){
        WshopList(this.data2).then(res=>{
          if(res.data.status=='ok'){
            res.data.result.data.map(item=>{
                item.checked = false
                this.empower.push(item)
            })
            this.flag1 = false
          }
        })
      },
      Scroll(e){
        const ele = e.srcElement ? e.srcElement : e.target
         // 监听滚动到div底部
        if (ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 100) { 
          if (this.flag == false) {//避免多次请求 加锁 该次请求完成 才能再次发起请求
            this.flag = true
            this.data.page += 1
            this.getList()
          }
        }
        
      },
      btnsClose(){
        this.ProductID  = ''
        this.notEmpow.map(item=>{
            if(item.flag==1){
              this.ProductID += item.ProductID + ','
            }
        })
        if (this.ProductID.length > 0) {
          this.ProductID  = this.ProductID.substr(0,this.ProductID.length - 1);
        }
        let data = {
          // JFYPrice:this.JFYPrice,
          ProductID:this.ProductID,
          token:window.sessionStorage.getItem('Token'),
          type:'2'
        }
        WshopDetele(data).then(res=>{
          if(res.data.status=='ok'){
            Message.success('取消授权成功')
            this.$emit('close')
          }else{
            Message.error(res.data.msg)
          }
        })
      },
      Bnts(){
        this.empower.map(item=>{
            if(item.checked==true){
              this.ProductID += item.ProductID + ','
            }
        })
        if (this.ProductID.length > 0) {
          this.ProductID  = this.ProductID.substr(0,this.ProductID.length - 1);
        }
        let data = {
          // JFYPrice:this.JFYPrice,
          ProductID:this.ProductID,
          token:window.sessionStorage.getItem('Token')
        }
        ImpowerProduct(data).then(res=>{
          console.log(res)
          if(res.data.status=='ok'){
            Message.success('授权成功')
            this.$emit('close')
          }else{
            Message.error(res.data.msg)
          }
        })
      },
      getList(){
        GetScenicList(this.data).then(res=>{
          if(res.data.status=='ok'){
            res.data.result.data.map(item=>{
              if(item.shopstate!='1'){
                this.notEmpow.push(item)
              }
            })
            this.notEmpow.map(itm=>{
              itm.checked = false
            })
            this.flag = false
          }
        })
      },
      closeContent(){
        this.empower.map((item,index)=>{
          if(item.checked){
            item.flag = 1
            this.notEmpow.unshift(item)
          }
        })
        for(let i=this.empower.length-1;i>=0;i--){
            if(this.empower[i].checked){
              this.empower.splice(i, 1);
            }
        }
        this.notEmpow.map(item=>{
          item.checked = false
        })
      },
      closeCon1(){
        this.empower.map((item,index)=>{
          item.flag = 1
          item.checked = false
          this.notEmpow.unshift(item)
        })
        this.empower = []
      },
      select(){
          if(this.price){
            this.notEmpow.map(item=>{
               if(item.checked){
                  item.JFYPrice= this.price 
                  this.empower.unshift(item)
               }
            })
          }else{
            this.notEmpow.map(item=>{
               if(item.checked){
                item.JFYPrice =  item.shopprice 
                this.empower.unshift(item)
               }
            })
          }
          for(let i=this.notEmpow.length-1;i>=0;i--){
              if(this.notEmpow[i].checked){
              this.notEmpow.splice(i, 1);
            }
          }
      },
      select1(){
        if(this.price){
            this.notEmpow.map(item=>{
              item.JFYPrice = this.price
              this.empower.unshift(item)
            })
          }else{
            this.notEmpow.map(item=>{
                item.JFYPrice +=  item.shopprice
                this.empower.unshift(item)
            })
          }
          for(let i=this.notEmpow.length-1;i>=0;i--){
              this.notEmpow.splice(i, 1);
              this.empower[i].checked = true
          }
      },
      pxFn(){
        this.addProDialogVisible = true
        this.titleType = '添加商品'
      },
      addProHandleClose(){
        this.addProDialogVisible = false
        this.$emit('close')
      }
    }
  }
</script>
<style scoped lang="less">
::v-deep .el-dialog__body{
  padding: 2rem 0 !important;
  border-top: 1px solid #E5E5EA;
}
.content{
  padding: 0 2rem 2rem 2rem;
  box-sizing: border-box;
  .contentBtns{
    margin-top: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      width: 10rem;
      height: 4rem;
      border-radius: 4px;
      line-height: 4rem;
      text-align: center;
      color: #fff;
      font-size: 1.4rem;
      cursor: pointer;
      background: #246DEB;
    }
  }
}
.contentQp {
  width: 100%;
  height: 490px;
  display: flex;
  justify-content: space-between;
  .qpLeft {
    width: 40rem;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
    span{
      color: #666;
    }
    >div{
      margin-bottom: 1.8rem;
    }
  }
  .qpRight {
    width: 40rem;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
    > div{
      font-style: normal;
      font-weight: 400;
      margin-bottom: 1.8rem;
      // color: #e74c3c;
      color: #666666;
      font-size: 1.4rem;
      span {
        margin-right: 10px;
        color: #666;
      }
    }
    
  }
}
.qpCenter{
  margin: 0 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .qpCenter_input{
    display: flex;
    flex-direction: column;
    span{
      color: #666;
      font-size: 1.4rem;
    }
    ::v-deep.el-input{
      margin-top: 1rem;
      width: 14rem;
    }
  }
  .qpCenter_btns{
    display: flex;
    flex-direction: column;
    >div{
      cursor: pointer;
      text-align: center;
      border-radius: 4px;
      
      width: 14rem;
      height: 4rem;
      line-height: 4rem;
      
      margin-top: 6rem;
      &:nth-child(1),&:nth-child(2){
        color: #246DEB;
        border: 1px solid #246DEB;
      }
      &:nth-child(3),&:nth-child(4){
        border: 1px solid #e74c3c;
        color: #e74c3c;
      }
    }
  }
}
.content_tops{
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  .top_btns{
      text-align: center;
      border-radius: 4px;
      background: #246DEB;
      width: 14rem;
      height: 4rem;
      line-height: 4rem;
      color: #fff;
      cursor: pointer;
      margin-left: 2rem;
  }
}
</style>